import { PageShell, Section } from "@/components/PageShell";

export default function CookiePolicy() {
  const openSettings = () => window.dispatchEvent(new Event("cc-open-consent"));
  return (
    <PageShell
      title="Cookie Policy"
      subtitle="What cookies and similar technologies CommandCenterADHD uses, and how you control them."
      testid="cookie-policy-page"
    >
      <Section heading="What cookies are">
        <p>
          Cookies are small files stored on your device. Similar technologies
          such as local storage and pixels work the same way. We use them to run
          the site and, only with your permission, to measure how the site is
          used.
        </p>
      </Section>

      <Section heading="Categories we use">
        <p className="font-semibold text-white">Necessary</p>
        <p>
          Required for the site to function, including your login session for the
          community and remembering your cookie choice. These are always active
          and cannot be switched off.
        </p>
        <p className="mt-4 font-semibold text-white">Analytics and marketing</p>
        <p>
          Optional. Only loaded after you select Accept. These include Google
          Analytics 4, the Meta Pixel, and PostHog, which help us understand
          traffic and improve the product and our advertising. If you Decline,
          none of these load and no optional analytics cookies are created.
        </p>
      </Section>

      <Section heading="Consent and how to change it">
        <p>
          When you first visit, a banner lets you Accept or Decline optional
          cookies. Analytics and marketing tools do not load until you Accept.
          You can change your choice at any time.
        </p>
        <p className="mt-4">
          <button
            type="button"
            onClick={openSettings}
            data-testid="cookie-settings-open-button"
            className="rounded-xl bg-[#F5A623] px-5 py-2.5 font-heading text-sm font-extrabold text-[#0B132B] transition-transform duration-200 hover:-translate-y-0.5"
          >
            Open cookie settings
          </button>
        </p>
      </Section>

      <Section heading="Managing cookies in your browser">
        <p>
          You can also block or delete cookies through your browser settings.
          Blocking necessary cookies may prevent parts of the site, such as
          community login, from working.
        </p>
      </Section>

      <Section heading="Questions">
        <p>
          Email{" "}
          <a href="mailto:support@commandcenteradhd.com" className="text-[#F5A623] underline">
            support@commandcenteradhd.com
          </a>{" "}
          with any question about how we use cookies.
        </p>
      </Section>
    </PageShell>
  );
}
